import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import { RegionsInstance } from '@/services/country-information/regions';
import { fetchRegionsActions, fetchCountriesByRegionActions } from '@/redux/actions/country-information/regions';

export function* fetchRegionsSaga(action: ActionType<typeof fetchRegionsActions.request>) {
  try {
    const { data, paging } = yield call(RegionsInstance.fetchRegions);
    yield put(fetchRegionsActions.success(data, paging));
  } catch (err) {
    yield put(fetchRegionsActions.failure(err));
  }
}

export function* fetchCountriesByRegionSaga(action: ActionType<typeof fetchCountriesByRegionActions.request>) {
  const { regionName } = action.payload;
  try {
    const { data, paging, meta } = yield call(RegionsInstance.fetchCountriesByRegion, regionName);
    yield put(fetchCountriesByRegionActions.success(data, paging, meta));
  } catch (err) {
    yield put(fetchCountriesByRegionActions.failure(err));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchRegionsActions.request.type, fetchRegionsSaga),
    takeLatest(fetchCountriesByRegionActions.request.type, fetchCountriesByRegionSaga),
  ]);
}
